import { baseRequest } from '@/utils/request'

const request = (url, ...arg) => baseRequest(`/biz/category/${url}`, ...arg)
/**
 * 招聘管理-基础配置接口管理
 * 
 */
export default {
    // 获取配置树
	basicTree(data) {
		return request('tree', data, 'get')
	},
	// 获取分页数据
	basicPage(data) {
		return request('page', data, 'get')
	},
	// 获取机构列表
	basicList(data) {
		return request('list', data, 'get')
	},
	// 获取配置详情
	basicDetail(data) {
		return request('detail', data, 'get')
	},
    // 提交配置表单 edit为true时为编辑，默认为新增
	submitForm(data, edit = false) {
		return request(edit ? 'edit' : 'add', data)
	},
    // 删除配置
	basicDelete(data) {
		return request('delete', data)
	},
}
